import { connect as formikConnect, Field } from 'formik';
import PropTypes from 'prop-types';
import React from 'react';

import { createBEM } from '../../../../lib/utils/css';
import { FormItemTypes } from '../constants';
import * as FormUtils from '../utils';

import './FormCheckbox.scss';

/**
 * @param  {string} id - unique id for the form field
 * @param  {string} theme - Is fed by parent Form
 * @param  {string} name - FormCheckbox input title
 * @param  {string} label - FormCheckbox label text
 * @param  {string | Node} description - FormCheckbox text
 * @param  {string} qaTag - qaTag
 * @param  {Any} formik - Provided by formik connect
 */

class FormCheckbox extends React.Component {
  static propTypes = {
    id: PropTypes.string,
    theme: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.node,
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    qaTag: PropTypes.string,
    formik: PropTypes.object,
  };

  render() {
    const { id, theme, name, label, description, qaTag, formik } = this.props;
    const checkboxClasses = createBEM('Form__checkbox', {
      [theme]: !!theme,
      error: FormUtils.shouldShowError(formik, name),
    });
    return (
      <label className={checkboxClasses} htmlFor={id}>
        <div className='Form__checkbox__input__wrapper'>
          <Field
            id={id}
            className='Form__checkbox__input'
            name={name}
            title={label}
            data-qa={qaTag}
            type={FormItemTypes.CHECKBOX}
            checked={formik.values[name]}
          />
          <span className='Form__checkbox__input--custom'></span>
        </div>
        <div className='Form__checkbox__description'>{description}</div>
      </label>
    );
  }
}

export default formikConnect(FormCheckbox);
